module.exports = __webpack_public_path__ + "media/images/icon_about4-33951e82ed32310b9fcaa6091405acef.png";